import { useQuery, type ApolloError } from '@apollo/client';
import type { MyMatterExpertsQuery } from '~/gql/graphql';
import { MyMatterExpertsDocument } from '~/graphql/queries/myMatterExperts';
import { useCurrentUser } from '~/shared/hooks/useCurrentUser';
import { UserRole } from '~/shared/types/connect';

/**
 * Attorneys only: distinct experts from the `myMatterExperts` query.
 * Row shape: `MyMatterExpertsRow` in `~/modules/matters/matters.types`.
 */
export function useMyMatterExpertsQuery(): {
  experts: MyMatterExpertsQuery['myMatterExperts'];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => Promise<unknown>;
} {
  const { user: currentUser } = useCurrentUser();
  const isAttorney = currentUser?.role === UserRole.ATTORNEY;
  const { data, loading, error, refetch } = useQuery<MyMatterExpertsQuery>(
    MyMatterExpertsDocument,
    {
      skip: !isAttorney,
      fetchPolicy: 'cache-first',
    },
  );

  return {
    experts: data?.myMatterExperts ?? [],
    loading,
    error,
    refetch,
  };
}
